<div class="container h-100">
    <div class="row h-100 justify-content-center align-items-center">
        <div *ngIf="isLoading == true" class="text-center">
            <app-loading-spinner></app-loading-spinner>
        </div>
        <div class="card SmallForm rounded col-11" *ngIf="isLoading == false && isOpen == false">
            <div class="card-body MyCardBody rounded-bottom">
                <div class="row">

                    <div class="form-group col-12" *ngIf="userId == null">
                        <div>Please enter your cell phone number</div>
                        <br>
                        <app-phone-verify [dial_code]="dial_code" [userExists]="true" [enabled]="true" [portrait]="true"
                            [phone_number]=" " (failed)="failedVerification()" (clearEvent)="clearCellPhone()"
                            (confirmNumber)="ConfirmCellPhone($event)"></app-phone-verify>
                    </div>
                    <div *ngIf="userId != null && members.length > 0" class="col-12">
                        <p class="mb-3 font-weight-bold text-center">Select the attendees, then tap Check-In.</p>
                    </div>
                    <div class="form-group col-7 col-xs-8 text-center" *ngIf="userId != null">
                        <div class="row" *ngIf="members.length > 0">
                            <div class="form-group col-11 m-auto text-center">
                                <div *ngFor="let member of members">
                                    <div class="row my-2">

                                        <button class="btn btn-block memberButton" (click)="toggleMember(member)"
                                            [ngClass]="{
                                 'btn-success':   
                                  member['checked'] == true,
                                'btn-light':                                  
                                  member['checked'] == false
                              }" type="button">
                                            <span>
                                                {{ member.firstName }}
                                                <i class="fas mt-1" style="float: right"
                                                    [class.fa-check-square]="member['checked'] == true"
                                                    [class.fa-square]="
                                    member['checked'] == false
                                  "></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-4 mt-2" *ngIf="userId != null">
                        <div class="row">
                            <div class="position-fixed">
                                <button class="btn btn-block btn-primary submitButton" type="button"
                                    [disabled]="isChecked() == false" (click)="submitCheckin()">
                                    <span>
                                        <i [ngClass]="{
                                    'fas fa-spinner fa-spin': processing
                                  }"></i>
                                        <div class="d-inline mx-1">
                                            {{ globalService.Get("CHECKIN") }}
                                        </div>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="userId != null && members.length > 0" class="col-12">
                        <p class="checkin-consent">
                            By checking in, you agree to the Church Services
                            <a href="https://church-services.com/terms-of-use/" target="_blank" rel="noopener noreferrer">Terms of Use</a>.
                        </p>
                    </div>
                </div>
            </div>              
        </div>
        <div *ngIf="isOpen == true">
            <br /><br /><br />
            <div class="alert alert-success text-center VerticalMargin" role="alert">
                <div class="acknowledgeCount">
                    {{ count }}
                </div>
                <h4>{{ globalService.Get("THANK_YOU") }}</h4> 
                {{ globalService.Get("CHECKIN_SUCCESSFUL") }} <br />
                <br />
                {{ globalService.Get("SHOW_USHER") }}
            </div>
        </div>        
    </div>
</div>